import { ReceivingLogRow } from "./ReceivingLogRow";
export class LogFilterParams {
    _ALL?: string;
    vendor?: string;
    jobNumber?: string;
    jobName?: string;
    jcDept?: string;
    poNumber?: string;
    items?: string;
    email?: string;
    quantity?: string;
    location?: string;
    dateIn?: string;
    dateOut?: string;
    takenBy?: string;
    shopFloorSF?: number;
    shipmentType?: string;
    loggedBy?: string;
    checkedOut?: boolean;
    notes?: string;
    storageFacility?: string;
  
    public constructor(init?: Partial<ReceivingLogRow>) {
      if (init) {
        // Safely assign properties to this instance
        Object.assign(this, init);
      }
    }
  }
  